/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_2_DescInputs */

const en_mk_sec_2_desc = /** @type {(inputs: Mk_Sec_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read-only, write to the workspace, or outbound action — you decide for every agent.`)
};

const id_mk_sec_2_desc = /** @type {(inputs: Mk_Sec_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca-saja, tulis workspace, atau aksi keluar — kamu yang menentukan tiap agen.`)
};

/**
* | output |
* | --- |
* | "Read-only, write to the workspace, or outbound action — you decide for every agent." |
*
* @param {Mk_Sec_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_2_desc = /** @type {((inputs?: Mk_Sec_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_2_desc(inputs)
	return en_mk_sec_2_desc(inputs)
});